<!--文件手动上传控件-->
<template>
  <div class="upload-manual" :class="{'upload-manual-disabled':disabled}">
    <div class="uoload-left">
      <div class="left-top">
        <span>请选择文件类型</span>
      </div>
      <div class="top-content">
        <el-tabs v-model="tabActivity" tab-position="left" @tab-click="typeChange">
          <el-tab-pane v-for="(item,index) in fileConfig" v-bind:key="index"
                       :label="(item.isMust?'*':'')+item.typeName"
                       :name="index+''"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="uoload-right">
      <div class="right-top" v-if="disabled===false">
        <el-upload
          class="upload-view"
          ref="upload"
          :action="action"
          :on-remove="handleRemove"
          :show-file-list="false"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :http-request="uploadFile"
          :on-progress="handleProgress"
          :on-change="onChange"
          :on-success="success"
          :auto-upload="autoUpload"
          :disabled="disabled">
          <el-button slot="trigger" size="small" type="primary" v-if="disabled===false">
            {{autoUpload?sumbitButtonName:'添加文件'}}
          </el-button>
          <el-button v-if="!autoUpload&&disabled===false" style="margin-left: 10px;" size="small" type="success"
                     @click="submitUpload">
            上传文件
          </el-button>
          <div class="el-upload__tip" slot="tip">{{fileTip}}</div>
        </el-upload>
      </div>
      <div class="right-content">
        <template>
          <el-table
            :data="uploadFileList"
            border
            style="width: 100%">
            <el-table-column
              prop="typeName"
              label="文件类型"
              min-width="130"
              align="center"
              :formatter="clmFileTypeNameFormat"
            >
            </el-table-column>
            <el-table-column
              prop="fileName"
              label="文件名称"
              min-width="250"
              align="center"
              :formatter="fileNameFormatter"
            >
            </el-table-column>
            <el-table-column
              prop="fileSize"
              label="大小"
              min-width="80"
              align="center"
              :formatter="clmSizeFormat">
            </el-table-column>
            <el-table-column
              v-if="!autoUpload"
              prop="status"
              label="状态"
              min-width="80" :formatter="clmStatusFormat">
            </el-table-column>
            <el-table-column label="操作" min-width="250" align="center">
              <template slot-scope="scope">
                <el-button v-if="isView(scope.$index, scope.row)"
                           size="mini"
                           @click="handleView(scope.$index, scope.row)">预览
                </el-button>
                <el-button v-if="scope.row.id"
                           size="mini"
                           @click="handleDownload(scope.$index, scope.row)">下载
                </el-button>
                <el-button v-if="!disabled"
                           size="mini"
                           type="danger"
                           @click="handleDelete(scope.$index, scope.row)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios';
    import Cookies from 'js-cookie'

    export default {
        name: 'UploadManual',
        props: {
            action: {
                type: String,
                required: true
            },
            onRemove: {
                type: Function,
                required: true
            },
            onPreview: {
                type: Function,
                required: true
            },
            onDownload: {
                type: Function,
                required: true
            },
            fileConfig: {
                type: Array,
                required: true
            },
            fileList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            autoUpload: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                fileTip: '', // 文件上传提示
                uploadFileList: [],
                fileConfigKey: {},
                tabActivity: '0', // 当前的文件类型
                currentFileConfig: null,
                fileUploadParams: {}, // 文件上传的参数 uid:{}
                sumbitButtonName: "" //上传文件按钮的名称
            }
        },
        methods: {
            submitUpload() {
                this.$refs.upload.submit();
            },
            handleRemove(file, fileList) {
                this.uploadFileList = Object.assign([], fileList);
                if (file.status === 'ready') {
                    return;
                }
                // 调用接口删除文件
                this.onRemove(file, fileList);
            },
            handlePreview(file) {
                console.log('handlePreview', file);
            },
            /**
             * 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
             */
            onChange: function (file, fileList) {
                if (this.currentFileConfig === null) {
                    this.currentFileConfig = this.fileConfig[0];
                }
                if (!file.type) {
                    // 第一次上传，检查文件大小和类型
                    if (!this.autoUpload) {
                        // 检查文件类型
                        if (this.currentFileConfig.fileAccept) {
                            let sFileName = file.name;
                            let sFileAccept = sFileName.substr(sFileName.lastIndexOf('.') + 1, sFileName.length);
                            if (this.currentFileConfig.fileAccept.indexOf(sFileAccept) < 0) {
                                this.$message.error('只能上传' + this.currentFileConfig.fileAccept + '类型的文件');
                                // 把当前上传的文件删除
                                this.$refs['upload'].handleRemove(file);
                                return;
                            }
                        }
                        // 检查文件大小
                        let fileSize = file.size;
                        if (this.currentFileConfig.maxSize) {
                            if (fileSize > (this.currentFileConfig.maxSize * 1024 * 1024)) {
                                this.$message.error('单个文件大小不能超过' + this.currentFileConfig.maxSize + 'Mb');
                                // 把当前上传的文件删除
                                this.$refs['upload'].handleRemove(file);
                                return;
                            }
                        }
                        let count = 0;
                        if (this.currentFileConfig.limit) {
                            for (let i = 0; i < this.uploadFileList.length; i++) {
                                let row = this.uploadFileList[i];
                                if (row.type === this.currentFileConfig.type) {
                                    count++;
                                    if (count >= this.currentFileConfig.limit) {
                                        this.$message.error('该类型文件只能上传' + this.currentFileConfig.limit + '个');
                                        // 把当前上传的文件删除
                                        this.$refs['upload'].handleRemove(file);
                                        return;
                                    }
                                }
                            }
                        }
                    }
                    file.configId = this.currentFileConfig.id;
                    file.type = this.currentFileConfig.type;
                    file.typeName = this.currentFileConfig.typeName;
                    file.fileName = file.name;
                    file.fileSize = file.size;
                    // 记录该文件上传时的参数
                    this.fileUploadParams[file.uid] = {
                        configId: this.currentFileConfig.id
                    };
                } else {
                    if (!file.id && file.response && file.response.data) {
                        file.id = file.response.data.id;
                    }
                }
                if (!this.autoUpload) {
                    this.uploadFileList = Object.assign([], fileList);
                }
            },
            uploadFile: function (from, b, c) {
                var formData = new FormData();
                // 根据后台接收参数格式进行修改
                let token = Cookies.get('token')
                // 1. 请求开始的时候可以结合 vuex 开启全屏 loading 动画
                // console.log(store.state.loading)
                // console.log('准备发送请求...')
                // 2. 带上token
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                if (token) {
                    config.headers.token = token;
                }
                formData.append('file', from.file);
                let uid = from.file.uid;
                let obj = this.fileUploadParams[uid];
                if (obj) {
                    for (let key in obj) {
                        formData.append(key, obj[key]);
                    }
                }
                from.onProgress(window.event);
                axios.post(from.action, formData, config).then(res => {
                    from.onSuccess(res.data);
                }).catch(err => {
                    from.onError(err);
                });
            },
            /**
             * 上传时的钩子
             * */
            handleProgress: function (event, file, fileList) {
                console.log('handleProgress', event, file, fileList);
            },
            /**
             * 文件上传前的钩子
             */
            beforeUpload: function (file) {
                if (!this.autoUpload) {
                    return;
                }
                if (this.currentFileConfig.fileAccept) {
                    let sFileName = file.name;
                    let sFileAccept = sFileName.substr(sFileName.lastIndexOf('.') + 1, sFileName.length);
                    if (this.currentFileConfig.fileAccept.indexOf(sFileAccept.toLowerCase()) < 0) {
                        this.$message.error('只能上传' + this.currentFileConfig.fileAccept + '类型的文件');
                        return false;
                    }
                }
                let fileSize = file.size;
                if (this.currentFileConfig.maxSize) {
                    if (fileSize > (this.currentFileConfig.maxSize * 1024 * 1024)) {
                        this.$message.error('单个文件大小不能超过' + this.currentFileConfig.maxSize + 'mb');
                        return false;
                    }
                }
                let count = 0;
                if (this.currentFileConfig.limit) {
                    for (let i = 0; i < this.uploadFileList.length; i++) {
                        let row = this.uploadFileList[i];
                        if (row.type === this.currentFileConfig.type) {
                            count++;
                            if (count >= this.currentFileConfig.limit) {
                                this.$message.error('该类型文件只能上传' + this.currentFileConfig.limit + '个');
                                return false;
                            }
                        }
                    }
                }
            },
            /**
             * 文件上传成功的钩子
             * */
            success: function (response, file, fileList) {
                if (!this.autoUpload) {
                    return;
                }
                this.uploadFileList = Object.assign([], fileList);
                this.$emit('onSuccess', response, file, fileList)
            },
            /**
             * 文件类型切换
             */
            typeChange: function () {
                // 获取文件配置
                this.currentFileConfig = this.fileConfig[this.tabActivity];
            },
            isView(index, row) {
                if (row.fileName) {
                    var fileExtension = row.fileName.substring(row.fileName.lastIndexOf('.') + 1)
                    if (fileExtension === 'pdf') {
                        return true
                    }
                }
            },
            /**
             * 预览文件(PDF文件)
             * @param {Object} index
             * @param {Object} row
             */
            handleView: function(index, row) {
                this.onPreview(row);
            },
            /**
             * 下载文件
             */
            handleDownload: function (index, row) {
                this.onDownload(row);
            },
            /**
             * 删除文件
             */
            handleDelete: function (index, row) {
                if (row.status !== 'ready') {
                    this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$refs['upload'].handleRemove(row);
                    }, () => {
                        console.log('取消')
                    });
                } else {
                    console.log(this.$refs['upload'].getFile());
                    this.$refs['upload'].handleRemove(row);
                }
            },
            /**
             * 格式化状态列
             * @param row
             * @param column
             * @param cellValue
             * @returns {string}
             */
            clmStatusFormat: function (row, column, cellValue) {
                if (cellValue === 'ready') {
                    return '待上传';
                } else {
                    return '已上传';
                }
            },
            /**
             * 格式化文件大小
             */
            clmSizeFormat: function (row, column, cellValue) {
                let MB = 1048576;
                let KB = 1024;
                if (cellValue > MB) {
                    return (Math.floor((cellValue / 1024 / 1024) * 100) / 100) + 'mb'
                } else if (cellValue > KB) {
                    return (Math.floor((cellValue / 1024) * 100) / 100) + 'kb'
                } else {
                    return cellValue + 'b'
                }
            },
            clmFileTypeNameFormat: function (row, column, cellValue) {
                let configId = row.configId;
                let config = this.fileConfigKey[configId];
                if (config) {
                    return config.typeName;
                }
            },
            /**
             * 初始化页面
             */
            initUI: function () {
                this.currentFileConfig = this.fileConfig[0];
                for (let i = 0; i < this.fileConfig.length; i++) {
                    let row = this.fileConfig[i];
                    this.fileConfigKey[row.id + ''] = row;
                }
            },
            fileNameFormatter: function (row, column, cellValue) {
                return row.saveName || cellValue
            },
            initUploadFile() {
                this.uploadFileList = Object.assign([], this.fileList);
            }
        },
        watch: {
            'currentFileConfig':
                function (val) {
                    let sTip = '';
                    if (val.limit && val.fileAccept.t) {
                        sTip += '该类型文件只能上传' + val.limit + '个（' + val.fileAccept + '）';
                    } else if (val.limit) {
                        sTip += '该类型文件只能上传' + val.limit + '个';
                    } else if (val.fileAccept) {
                        sTip += '只能上传' + val.fileAccept + '类型的文件';
                    }
                    if (val.maxSize) {
                        sTip += ',且单个文件不超过' + val.maxSize + 'mb';
                    } else {
                        sTip += '。';
                    }
                    this.fileTip = sTip;
                    this.sumbitButtonName = "上传" + val.typeName
                },
            'fileList': function (val) {
                this.initUploadFile()
            },
            fileConfig(value) {
                this.initUI();
            }
        },
        mounted() {
            if (this.fileConfig.length === 0) {
                return;
            }
            this.initUI();
        }
    }
</script>

<style scoped lang="less">
  .upload-manual.upload-manual-disabled {
    padding-left: 0px !important;

    .uoload-left {
      display: none;
    }
  }

  .upload-manual {
    padding-left: 150px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;

    .uoload-left {
      width: 150px;
      height: 100%;
      margin-left: -150px;
      float: left;
      text-align: right;

      .left-top {
        height: 70px;
        display: flex;
        align-items: center;
        text-align: center;

        span {
          display: block;
          margin: 0 auto;
        }
      }
    }

    .uoload-right {
      width: 100%;
      padding-right: 10px;
      box-sizing: border-box;
      padding-top: 10px;

      .right-top {
        height: 70px;
        display: flex;
        align-items: center;
        padding-left: 20px;
      }
    }

    .upload-view {
      text-align: left;
    }
  }
</style>
<style lang="less">
  .upload-manual {
    border-radius: 5px;
    border: 1px solid #dcdfe6;

    .el-tabs--left {
      display: inline-block;

      .el-tabs__content {
        display: none;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/Core/UploadManual.vue